import React from "react";
import Card from "components/card";
import { Divider } from "antd";
import { formatDateRange } from "utils/index";
import LeaveApprovalForm from "views/console/attendances/leave-requests/components/LeaveApprovalForm";
import OvertimeApprovalForm from "views/console/attendances/overtime-requests/components/OvertimeApprovalForm";
import ApprovalButtons from "components/button/approvalbuttons";
import { MODULE_LEAVE_REQUESTS, MODULE_OVERTIME_REQUESTS } from "variables/constants";
import EmployeeProfile from "components/card/EmployeeProfile";
import LeaveWorkflowCard from "./LeaveWorkflowCard";
import OvertimeWorkflowCard from "./OvertimeWorkflowCard";


const WORKFLOW_CONFIG = {
  Leave: {
      WorkflowCard: LeaveWorkflowCard,
      FormComponent: LeaveApprovalForm,
      moduleId: MODULE_LEAVE_REQUESTS,
      recordIdKey: "lve_id",
      modalPrefix: "edit_leave_request",
      reasonKey: "lve_reason",
  },
  Overtime: {
      WorkflowCard: OvertimeWorkflowCard,
      FormComponent: OvertimeApprovalForm,
      moduleId: MODULE_OVERTIME_REQUESTS,
      recordIdKey: "ots_id",
      modalPrefix: "edit_overtime_request",
      reasonKey: "ots_reason",
  },
};

const ApprovalCard = ({ workflow }) => {

  const {
    type,
    date_file,
    status_name,
  } = workflow;

  const config = WORKFLOW_CONFIG[type];

  if (!config) {
    return null;
  }

  const {
    WorkflowCard,
    FormComponent,
    moduleId,
    recordIdKey,
    modalPrefix,
    reasonKey,
  } = config;

  const reason = workflow[reasonKey];
  
  return (

    <Card className="p-4 rounded-2xl border-2 border-orange-200 bg-white hover:border-orange-300 hover:shadow-md transition-all duration-200 space-y-3 overflow-hidden dark-mode-card">        
      <div className="flex items-start justify-between gap-2 overflow-hidden">
        <div className="flex items-center justify-between gap-3 w-full">
          <EmployeeProfile
            record={workflow}
            withEmpLocation={true}
            withEmpId={false}
            empNameClass="text-[14px] font-semibold truncate dark:text-white"
            nameInitialBg="bg-slate-100 dark:bg-slate-700"
          />

          <span
            className={`flex items-center text-xs border status-indicator ${type?.toLowerCase().replace(/\s+/g, "-")}`}
          >
            {type}
          </span>
        </div>
      </div>

      <Divider style={{ margin: "0.5rem 0", borderColor: "#e5e7eb" }} />

      <div className="space-y-3">
        <WorkflowCard workflow={workflow} />

        <div className="p-3 rounded-xl bg-slate-50 border dark-mode-card">
          <span className="text-[11px] text-slate-700 font-semibold uppercase tracking-wide dark:text-slate-100">
            Reason
          </span>
          <p className="text-[12px] mt-1 break-words dark:text-white">
            {reason}
          </p>
        </div>
        <div className="text-[11px] text-slate-700 tracking-normal font-medium gap-1 dark:text-slate-100">
          Requested on {formatDateRange(date_file)}
        </div>

        {status_name !== "Approved" && status_name !== "Declined" ? (
          <div className="flex mt-4 gap-3">
            <ApprovalButtons
              record={workflow}
              recordIdKey={recordIdKey}
              employeeNameKey="employee_name"
              moduleId={moduleId}
              FormComponent={FormComponent}
              modalPrefix={modalPrefix}
            />
          </div>
        ) : (
          <div className="mt-4 p-3 rounded-xl bg-slate-50 border text-center">
            <p className="text-sm font-medium text-slate-600 dark:text-slate-200">
              This {type.toLowerCase()} request has already been {status_name?.toLowerCase()}.
            </p>
          </div>
        )}
      </div>
      
    </Card>

  );
};

export default ApprovalCard;

